/** Normaliza códigos de idioma del widget (`en-US`, `pt_BR`, `cat` → `ca`, `sp` → `es`). Sin valor → `es`. */
export function normalizeWidgetLang(code: string | null | undefined): string {
  if (code == null || typeof code !== 'string') {
    return 'es';
  }
  const trimmed = code.trim().toLowerCase();
  if (!trimmed) {
    return 'es';
  }
  const base = trimmed.split('-')[0].split('_')[0];
  if (base === 'cat') {
    return 'ca';
  }
  // `sp` es el idioma de arranque que guarda `setupTranslateServiceFactory` en localStorage.
  if (base === 'sp') {
    return 'es';
  }
  return base;
}

/** Lee `lang` de la URL (`?lang=ca` en search o en el hash). */
export function getLangFromQueryParams(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const fromSearch = new URLSearchParams(window.location.search).get('lang');
  if (fromSearch?.trim()) {
    return fromSearch.trim();
  }

  const hash = window.location.hash;
  const hashQueryIndex = hash.indexOf('?');
  if (hashQueryIndex !== -1) {
    const fromHash = new URLSearchParams(hash.substring(hashQueryIndex + 1)).get('lang');
    if (fromHash?.trim()) {
      return fromHash.trim();
    }
  }

  return null;
}

/**
 * Resuelve el idioma activo del widget.
 * Prioridad: `@Input` / explícito → store → query params → localStorage → `es`.
 */
export function resolveWidgetLang(
  explicitLang?: string | null,
  storeLang?: string | null
): string {
  const candidates = [
    explicitLang,
    storeLang,
    getLangFromQueryParams(),
    typeof localStorage !== 'undefined' ? localStorage.getItem('belender-language') : null,
  ];

  for (const candidate of candidates) {
    if (candidate != null && String(candidate).trim()) {
      return normalizeWidgetLang(candidate);
    }
  }

  return 'es';
}
